<template>
    <div>
        <BannerManger :type="1"></BannerManger>
    </div>
</template>

<script>
import BannerManger from "page/xSchool/manager/BannerManger.vue";
export default {
  data(){
      return {
          
      }
  },
  components:{
      BannerManger
  }
}
</script>

<style>

</style>
